export const checkLoggedInCustomer = (navigate) => {
  const customer = localStorage.getItem("loggedInCustomer");
  if (customer == null || customer == undefined) {
    navigate("/customer/login");
  }
};

export const checkLoggedInAdmin = (navigate) => {
  const admin = localStorage.getItem("adminData");
  if (admin == null || admin == undefined) {
    navigate("/adminlogin");
  }
};